var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './styles.module.scss';
import { Divider } from '../../../../shared/engage/components/divider/divider';
import { useBreakpoints } from '../../hooks/use-get-breakpoints';
export var Option = function (_a) {
    var _b;
    var children = _a.children, value = _a.value, onClick = _a.onClick, isLastOption = _a.isLastOption, _c = _a.withDivider, withDivider = _c === void 0 ? false : _c, _d = _a.automationId, automationId = _d === void 0 ? null : _d, restButtonProps = __rest(_a, ["children", "value", "onClick", "isLastOption", "withDivider", "automationId"]);
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var handleClick = function () {
        onClick === null || onClick === void 0 ? void 0 : onClick(value);
    };
    return (_jsxs(_Fragment, { children: [_jsx("button", __assign({ type: "button", className: classNames(styles.option, (_b = {}, _b[styles.last] = isLastOption, _b)), onClick: handleClick, "data-automation-id": "option:".concat(automationId, ":").concat(value) }, restButtonProps, { children: children })), ((isMobileOrSmaller && !isLastOption) || withDivider) && _jsx(Divider, {})] }));
};
